import { motion } from "framer-motion";

function RecordsModeToggle({ mode, onChange, options = [] }) {
    const baseClasses = "relative z-10 flex-1 min-w-[100px] md:min-w-[140px] px-4 md:px-6 py-2.5 rounded-lg text-xs md:text-sm font-bold text-center transition-colors duration-200";

    return (
        <div className="flex w-full max-w-4xl flex-wrap p-1 bg-[#0f1f15] border border-white/10 rounded-xl shadow-2xl gap-1">
            {options.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    onClick={() => onChange(option.id)}
                    className={`${baseClasses} ${mode === option.id ? "text-[#062a1a]" : "text-slate-400 hover:text-white"}`}
                >
                    {mode === option.id ? (
                        <motion.span
                            layoutId="records-mode-toggle-pill"
                            transition={{ type: "spring", stiffness: 420, damping: 34 }}
                            className="absolute inset-0 -z-10 rounded-lg bg-green-500"
                        />
                    ) : null}
                    {option.label}
                </button>
            ))}
        </div>
    );
}

export default RecordsModeToggle;
